
<div align="center" layout="row">
  <div layout="row" layout-margin align="center" class="mt75">
    <div *ngIf="showMessage" class="marquee">
      <div class="marquee-content">
        {{ message }}
      </div>
    </div>
    <div flex style="display: inline-block">
      <mat-label style="display: inline-block">
        <h5>Search Power Supply Notebook</h5>
      </mat-label>
    </div>
  </div>

  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find Node</mat-label>
    <input #node matInput placeholder="Enter Node" [formControl]="searchTerm"  (keyup)="onChangesearchpowersupplies($event)"  (keydown)="onChangesearchpowersupplies($event)" [matAutocomplete]="auto"
      autocomplete="off">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="nodeSelected($event)" [displayWith]="getNodeName">
      <mat-option *ngFor="let item of searchResult" [value]="item">
        <span>{{ item.node }} / {{ item.nodeCmts }} </span>
      </mat-option>
    </mat-autocomplete>
    <button (click)="onchangesearchPSNav()" [disabled] = "searchnodeFlag" class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find Power Supply Name</mat-label>
    <input matInput placeholder="Enter Power Supply Name" [formControl]="powerSupplyNameSearchTerm"
      [matAutocomplete]="PSNameAuto" autocomplete="off">
    <mat-autocomplete #PSNameAuto="matAutocomplete" (optionSelected)="searchByPowerSupplyName($event)"
      [displayWith]="getPowerSupplyName">
      <mat-option *ngFor="let item of psNameSearchResult" [value]="item">
        <span>{{ item.powerSupplyName}}</span>
      </mat-option>
    </mat-autocomplete>
    <button class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find MAC Address</mat-label>
    <input matInput placeholder="Enter MAC Address" (keydown.space)="$event.preventDefault()" (keypress)="omit_special_char($event)" min="0" max="17" maxlength="17" [value]="mac_address" [formControl]="macSearchFormControl"
      [matAutocomplete]="macAuto" autocomplete="off">
    <mat-autocomplete #macAuto="matAutocomplete" (optionSelected)="searchByMacAddress($event)"
      [displayWith]="getMacAddress">
      <mat-option *ngFor="let item of macSearchResult" [value]="item">
        <span>{{ item.mac}}</span>
      </mat-option>
    </mat-autocomplete>
    <button class="button" style="border: none;background: #fafafa;" *ngIf="isLoadingmacdata" matSuffix color="red">
      <mat-spinner  diameter="25"></mat-spinner>
    </button>
    <button class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find Power Supply ID</mat-label>
    <input matInput (keypress)="numberOnly($event)" placeholder="Enter Power Supply ID" [formControl]="psIdControl" [matAutocomplete]="psidAuto">
    <mat-autocomplete #psidAuto="matAutocomplete" (optionSelected)="searchPSID($event)" [displayWith]="getpowerSupplyId">
      <mat-option *ngFor="let item of psIDResult" [value]="item">
        <span>{{ item.powerSupplyId}}</span>
      </mat-option>
    </mat-autocomplete>
    <!-- <input #latitude matInput placeholder="Enter Power Supply ID" (keyup)="searchPSID($event)" [formControl]="psIdControl"> -->
    <button class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find Town/Headend</mat-label>
    <input matInput placeholder="Enter Town Or Headend" [formControl]="headendSearchFormControl"
      [matAutocomplete]="headendAuto" autocomplete="off">
    <mat-autocomplete #headendAuto="matAutocomplete" (optionSelected)="searchByHeadendOrCommunity($event)"
      [displayWith]="getHeadendOrTown">
      <mat-option *ngFor="let item of headendOrTownSearchResult" [value]="item">
        <span>{{ item.headendOrTown}}</span>
      </mat-option>
    </mat-autocomplete>
    <button class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="mat-form-field-infix-class" appearance="outline">
    <mat-label>Find PS Address</mat-label>
    <input matInput placeholder="Enter PS Address" [formControl]="addressSearchFormControl"
      [matAutocomplete]="addressAuto" autocomplete="off">
    <mat-autocomplete #addressAuto="matAutocomplete" (optionSelected)="searchByAddress($event)"
      [displayWith]="getAddress">
      <mat-option *ngFor="let item of addressSearchResult" [value]="item">
        <span>{{ item.address}}</span>
      </mat-option>
    </mat-autocomplete>
    <button class="button" mat-mini-fab matSuffix color="red">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <p>
    <mat-form-field appearance="outline" class="mat-form-field-infix-gps" hideRequiredMarker="true">
      <mat-label>Lat</mat-label>
      <input #latitude matInput placeholder="Enter Latitude" (click)="getLocation()" [formControl]="gpsLatControl">
      <mat-error *ngIf="gpsLatControl.errors">
        Latitude is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-infix-gps" hideRequiredMarker="true">
      <mat-label>Long</mat-label>
      <input #longitude matInput placeholder="Enter Longitude" [formControl]="gpsLongControl">
      <mat-error *ngIf="gpsLongControl.errors">
        Longitude is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <!-- <mat-form-field appearance="outline" class="mat-form-field-infix-gps-region">
      <mat-select placeholder="Select Region" #regionValue [formControl]="regionFormControl">
        <mat-option *ngFor="let region of regionList" [value]="region">
          {{region.label}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="regionFormControl.errors">
        Region is <strong>required</strong>
      </mat-error>
    </mat-form-field> -->
    <button mat-mini-fab matSuffix color="accent"
      [disabled]="((!gpsLongControl.valid) || (!gpsLatControl.valid))"
      (click)="searchByLocation(latitude.value,longitude.value)">
      <mat-icon>search</mat-icon>
    </button>
  </p>
  <br>

  <hr class="horizontal-line">
  <button class="button generator-search-button" mat-button routerLink="/generatorsearch">
    <span aria-hidden="true" class="fa fa-search navicon"></span>
    Generator Search
  </button>
</div>
